import styled from 'styled-components';

import { rem } from 'approot/shared/style';
import { orange1 } from 'approot/shared/styles/colours.style';
import { spacing16, spacing24 } from 'approot/shared/styles/spacing.style';
import { font14 } from 'approot/shared/styles/typography.style';
import { borderRadius16 } from 'approot/shared/styles/borders.style';

export const ClassesBannerInfo = styled.div`
  background-color: ${orange1};
  border-radius: ${rem(borderRadius16)};
  margin-bottom: ${rem(spacing24)};
  padding: ${rem(spacing16)};
`;

export const ClassesBannerInfoText = styled.div`
  ${font14}
  margin-bottom: ${rem(spacing16)};
`;
